import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { BellIcon } from '../../../icons/animated';
import { NAVBAR_MENU_KEYS, NS } from '../../../i18n/constants/keys';

const NOTIFICATION_KEYS = [
  NAVBAR_MENU_KEYS.notifications.welcome,
  NAVBAR_MENU_KEYS.notifications.assessmentReady,
  NAVBAR_MENU_KEYS.notifications.newApplication,
] as const;

export const Notifications = () => {
  const { t } = useTranslation(NS.navbarMenus);
  const [menuOpen, setMenuOpen] = useState(false);
  const [isHovered, setIsHovered] = useState(false);
  const menuRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
        setMenuOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <div className='relative' ref={menuRef}>
      <button
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            setMenuOpen(!menuOpen);
          }}
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
          className='p-1 hover:bg-[var(--navbar-btn-hover,rgba(255,255,255,0.1))] rounded transition-colors relative'
          aria-label="Notifications"
      >
        <BellIcon isHovered={isHovered} size={22} className='text-[var(--navbar-text,#ffffff)]' />
        { NOTIFICATION_KEYS.length > 0 && (
          <span className='absolute -top-1 -right-1 h-3 w-3 bg-red-500 rounded-full flex items-center justify-center text-xs text-white'>
            { NOTIFICATION_KEYS.length }
          </span>
        ) }
      </button>

      { menuOpen && (
        <div
            className='absolute p-2 right-0 mt-2 w-56 bg-white border border-gray-200 shadow-lg rounded-lg pt-2 max-h-96 overflow-y-auto'
            style={{ maxHeight: '400px', zIndex: 9999 }}
        >
          { (NOTIFICATION_KEYS.length as number) === 0 ? (
            <div className='text-center text-sm text-gray-500'>
              {t(NAVBAR_MENU_KEYS.notifications.empty)}
            </div>
          ) : (
            NOTIFICATION_KEYS.map((notificationKey) => (
              <div
                  key={notificationKey}
                  className='p-2 border-b text-sm text-gray-700'
              >
                { t(notificationKey) }
              </div>
            ))
          ) }
        </div>
      ) }
    </div>
  );
};
